import React, { Suspense } from 'react';
import { Flex, RootScreen, Spinner, useScreenSize } from '@banhala/ui-kit';
import { MarketHomeContents } from './components/MarketHomeContents';
import { ScreenStateProvider } from './states/ScreenStateProvider';
import { MarketAnalyticsProvider } from './components/MarketAnalyticsProvider';
import { MarketHomeParentMarketRedirectGuard } from './components/MarketHomeParentMarketRedirectGuard';
import { useMarketRoute } from '../../hooks/useMarketRoute';
const MarketHome = () => {
  const { width } = useScreenSize();
  const { params } = useMarketRoute<'MarketHome'>();

  if (isNaN(params.marketId)) {
    throw new Error(
      `유효하지 않은 마켓 ID입니다. marketId: ${params.marketId}`,
    );
  }

  return (
    <RootScreen>
      <ScreenStateProvider>
        <Suspense
          fallback={
            <Flex
              flex={1}
              width={width}
              padding={{ horizontal: 12 }}
              margin={{ horizontal: 'auto' }}
            >
              <Flex.Center flex={1}>
                <Spinner size={20} />
              </Flex.Center>
            </Flex>
          }
        >
          <MarketHomeParentMarketRedirectGuard marketId={params.marketId}>
            <MarketAnalyticsProvider marketId={params.marketId}>
              <MarketHomeContents />
            </MarketAnalyticsProvider>
          </MarketHomeParentMarketRedirectGuard>
        </Suspense>
      </ScreenStateProvider>
    </RootScreen>
  );
};

export default MarketHome;
